import {
  CATEGORIE_REGROUPEMENT,
  CATEGORIE_UNITAIRE,
  CATEGORIE_REGROUPEMENT_MAIRIE,
  CATEGORIE_REGROUPEMENT_LC,
} from '@/configuration/catalogue/produitConf';

export const CATEGORIE_PRODUIT_LOGISTIQUE = [
  {
    code: CATEGORIE_UNITAIRE,
    libelle: 'catalogue.type.face',
  },
  {
    code: CATEGORIE_REGROUPEMENT,
    libelle: 'catalogue.type.reseauTempo',
  },
  {
    code: CATEGORIE_REGROUPEMENT_MAIRIE,
    libelle: 'catalogue.type.reseauMairie',
  },
  {
    code: CATEGORIE_REGROUPEMENT_LC,
    libelle: 'catalogue.type.reseauLc',
  },
];

export const TYPE_DEMANDE_AUTO = 'TYPE_DEMANDE_AUTO';

export const TYPE_DEMANDE_LOGISTIQUE = 'TYPE_DEMANDE_LOGISTIQUE';

export const EXPORT_EXCEL_DEMANDES_MANUELLES = 'demandesmanuelles';

export const ACTION_CHANGEMENT_ETAT_TRAITE = 'CHANGEMENT_ETAT_TRAITE';
export const ACTION_CHANGEMENT_ETAT_NOUVEAU = 'CHANGEMENT_ETAT_NOUVEAU';
export const ACTION_VERROUILLAGE_DEMANDE = 'VERROUILLAGE_DEMANDE';
export const ACTION_DEVERROUILLAGE_DEMANDE = 'DEVERROUILLAGE_DEMANDE';
